/*eslint no-undef: 0*/

// Global variables
const $page = $('html, body');

/**
 * Remove 'no-js' class from the root of the page
 */
document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');


/**
 * Add classes to the body element on DOM and Window load
 */
document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.add('content-loaded');
});

window.addEventListener('load', function () {
  document.body.classList.add('page-loaded');
});


/**
 * Set user agent on root element
 */
const setUserAgent = () => {
  document.documentElement.setAttribute('data-useragent', navigator.userAgent);
  document.documentElement.setAttribute('data-platform', navigator.platform);
};


/**
 * Detect if device is touch or not
 * @returns {boolean}
 */
const isTouchDevice = () => {
  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) return true;
  if ((('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) === undefined) return false;
};

//
const toggleTouchDeviceClasses = () => {
  if (isTouchDevice()) document.documentElement.classList.add('is-touch');
  if (!isTouchDevice()) document.documentElement.classList.add('no-touch');
};


/**
 * Const get device specific breakpoints
 * @returns {{iPadBreakpoint: number, mblBreakpoint: number}}
 */
const getDeviceBreakpoints = () => {
  let mblBreakpoint = null;
  let iPadBreakpoint = null;
  if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
    mblBreakpoint = 767;
    iPadBreakpoint = 991;
  } else {
    mblBreakpoint = 767 - 17; // 17px scrollbar width
    iPadBreakpoint = 991 - 17; // 17px scrollbar width
  }
  return {
    mblBreakpoint,
    iPadBreakpoint,
  };
};


/**
 * Prevent Bootstrap's dropdown menu auto close when clicked inside
 */
const disableBSDropdownAutoClose = () => {
  const dropdownMenus = document.querySelectorAll('.dropdown-menu');
  if (dropdownMenus.length === 0) return;
  [].forEach.call(dropdownMenus, elem => {
    elem.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });
};


/**
 * Gravity form custom actions
 */
const gravityFormActions = () => {
  let isPageLoaded = false;
  const header = document.getElementById('masthead');

  $(document).on('click', '.gf_button', function () {
    $(this).addClass('is-processing');
    isPageLoaded = true;
  });

  // eslint-disable-next-line no-unused-vars
  $(document).on('gform_post_render', function (event, form_id, current_page) {
    // Button styling
    const $button = $('.gf_button');
    const $formWrapper = $('#gform_wrapper_' + form_id);

    // If page is loaded
    if (isPageLoaded) {
      $page.animate({
        scrollTop: $formWrapper.offset().top - header.clientHeight + 1,
      }, {
        duration: 0, easing: 'easeInOutQuint', complete: function () {
          isPageLoaded = false;
        },
      });
    }

    // Remove is-processing class from the button
    $button.removeClass('is-processing');
  });
};


/**
 * Input placeholder toggle
 */
const inputPlaceholderToggle = () => {
  let defaultPlaceholder;

  document.addEventListener('focusin', e => {
    if (e.target && (e.target.nodeName === 'INPUT' || e.target.nodeName === 'TEXTAREA')) {
      let self = e.target;
      if (typeof self === 'undefined') return;
      defaultPlaceholder = self.getAttribute('placeholder');
      self.setAttribute('placeholder', '');
    }
  });

  document.addEventListener('focusout', e => {
    if (e.target && (e.target.nodeName === 'INPUT' || e.target.nodeName === 'TEXTAREA')) {
      let self = e.target;
      if (typeof self === 'undefined') return;
      self.setAttribute('placeholder', defaultPlaceholder === null ? '' : defaultPlaceholder);
    }
  });
};


/**
 * Add new tab message for the screen readers
 * @link https://codersblock.com/blog/external-links-new-tabs-and-accessibility/
 */
const addNewTabMessage = () => {
  const links = document.querySelectorAll('a[target="_blank"]');
  [].forEach.call(links, link => {
    if (!link.querySelector('.sr-only'))
      link.insertAdjacentHTML('beforeend', '<span class="sr-only">(Opens in a new tab)</span>');
  });
};


/**
 * Check if the browser has a scrollbar
 * @link https://tylercipriani.com/blog/2014/07/12/crossbrowser-javascript-scrollbar-detection/
 * @returns {boolean}
 */
const browserHasScrollbar = () => {
  // The Modern solution
  if (typeof window.innerWidth === 'number')
    return window.innerWidth > document.documentElement.clientWidth;

  // rootElem for quirksmode
  let rootElem = document.documentElement || document.body;

  // Check overflow style property on body for fauxscrollbars
  let overflowStyle;

  if (typeof rootElem.currentStyle !== 'undefined')
    overflowStyle = rootElem.currentStyle.overflow;

  overflowStyle = overflowStyle || window.getComputedStyle(rootElem, '').overflow;

  // Also need to check the Y axis overflow
  let overflowYStyle;

  if (typeof rootElem.currentStyle !== 'undefined')
    overflowYStyle = rootElem.currentStyle.overflowY;

  overflowYStyle = overflowYStyle || window.getComputedStyle(rootElem, '').overflowY;

  const contentOverflows = rootElem.scrollHeight > rootElem.clientHeight;
  const overflowShown = /^(visible|auto)$/.test(overflowStyle) || /^(visible|auto)$/.test(overflowYStyle);
  const alwaysShowScroll = overflowStyle === 'scroll' || overflowYStyle === 'scroll';

  return (contentOverflows && overflowShown) || (alwaysShowScroll)
};

/**
 * Add Class to the root element depending upon browser having scrollbar
 */
const addScrollbarClass = () => {
  const html = document.documentElement;

  if (browserHasScrollbar()) {
    html.classList.add('has-scrollbar');
  } else {
    html.classList.remove('has-scrollbar');
  }
};


/**
 * Resize handlers in window resize
 */
const activateResizeHandler = () => {
  const resizeClass = 'resize-active';
  let flag, timer;

  let removeClassHandler = () => {
    flag = false;
    document.documentElement.classList.remove(resizeClass);
  };

  const resizeHandler = () => {
    if (!flag) {
      flag = true;
      document.documentElement.classList.add(resizeClass);
    }
    clearTimeout(timer);
    timer = setTimeout(removeClassHandler, 10);
  };

  window.addEventListener('resize', resizeHandler);
  window.addEventListener('orientationchange', resizeHandler);
};


export {
  activateResizeHandler,
  addNewTabMessage,
  addScrollbarClass,
  disableBSDropdownAutoClose,
  getDeviceBreakpoints,
  gravityFormActions,
  inputPlaceholderToggle,
  isTouchDevice,
  setUserAgent,
  toggleTouchDeviceClasses,
}



// WEBPACK FOOTER //
// ./scripts/util/util.js